import './index.less'
import { useEffect, useState } from 'react';
import { getCycleAward } from '@/api/reward-rules'
import { RewardData } from '@/interface/reward-rules'
import { getUrlParams } from '@/utils/common'

const RewardRules = () => {
  const category: string = getUrlParams('category');
  const [weekRewardData, setWeekRewardData] = useState<RewardData[]>([])
  const [monthRewardData, setMonthRewardData] = useState<RewardData[]>([])

  useEffect(() => {
    getCycleAward(category).then(e => {
      setWeekRewardData(e?.[0].detail)
      setMonthRewardData(e?.[1].detail)
    })
  }, [category])

  return (
    <div className='reward-rules'>

      <div className="reward-section">
        {weekRewardData?.length && (<>
          <div className="section-title week-section">
            <span className="dot" />
            <span className="title-text">周奖励</span>
          </div>
          <div className="section-desc">
            <p>周接单时长计算以自然周为准，满足发放要求后阶梯发放对应奖励，低于{weekRewardData[0].duration}小时无周奖励</p>
            <p>• 发放时间：次周周三(可能会出现1-2天延迟)</p>
            <p>• 接单时长：上周已成功完成订单的接单时长</p>
            <p>• 奖励金额：课时费(未抽成) x 奖励比例</p>
            <p>• 课时费：上周已成功完成订单的课时费</p>
          </div>
          <div className="table-title">
            <div className='left' />
            <span>奖励比例</span>
            <div className='right' />
          </div>
          <div className="reward-table">
            <div className="table-header">
              <span>接单时长(小时)</span>
              <span>奖励比例</span>
            </div>
            {weekRewardData.map((item: RewardData, index: number) => (
              <div key={index} className="table-row">
                <span>{item.duration}</span>
                <span>{item.award_rate}%</span>
              </div>
            ))}
          </div>
        </>)}

        {monthRewardData?.length && (<>
          <div className="reward-section">
            <div className="section-title month-section">
              <span className="dot" />
              <span className="title-text">月奖励</span>
            </div>
            <div className="section-desc">
              <p>月接单时长计算以自然月为准，满足发放要求后阶梯发放对应奖励，低于{monthRewardData[0].duration}小时无月奖励</p>
              <p>• 发放时间：次月10号(可能出现1-2天延迟，如遇国家法定节假日自动延期)</p>
              <p>• 接单时长：上月已成功完成订单的接单时长</p>
              <p>• 奖励金额：课时费(未抽成) x 奖励比例</p>
              <p>• 课时费：上月已成功完成订单的课时费</p>
            </div>
            <div className="table-title">
              <div className='left' />
              <span>奖励比例</span>
              <div className='right' />
            </div>
            <div className="reward-table">
              <div className="table-header">
                <span>接单时长(小时)</span>
                <span>奖励比例</span>
              </div>
              {monthRewardData.map((item: RewardData, index: number) => (
                <div key={index} className="table-row">
                  <span>{item.duration}</span>
                  <span>{item.award_rate}%</span>
                </div>
              ))}
            </div>
          </div>
        </>)}

        {/* 奖励发放说明模块 */}
        <div className="reward-section">
          <div className="section-title desc-section">
            <span className="dot" />
            <span className="title-text">奖励发放说明</span>
          </div>
          <div className="section-desc">
            <p />
            <p>• 以订单服务开始时间计入统计周期。比如，订单服务时间为上周日23点~本周一1点，开始时间为上周日，故该订单纳入上周周奖励</p>
            <p>• 退款等异常订单时长、课时费不计算入内</p>
            <p>• 若教练行为不符合平台规则，产生违规、投诉等，平台有权不发放奖励</p>
            <p>• 可通过 我的-我的钱包-账单 查看周月奖励到账明细</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RewardRules